import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';

const Contact = () => {
  useEffect(() => {
    // Load Typeform widget script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on component unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Box sx={{ backgroundColor: '#24242a', minHeight: '100vh', pt: 12 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontWeight: 700,
            color: 'white',
            mb: 3,
            textAlign: 'center',
          }}
        >
          Contact Us
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '1.2rem',
            color: 'rgba(255, 255, 255, 0.8)',
            textAlign: 'center',
            mb: 6,
          }}
        >
          Get in touch to learn how MotionLogic® can help enhance safety and improve productivity
        </Typography>

        <Grid container justifyContent="center">
          <Grid item xs={12} md={10}>
            <Paper
              sx={{
                backgroundColor: '#2d2d33',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                p: 4,
              }}
            >

              <Box
                sx={{
                  width: '100%',
                  height: '600px',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: 1,
                  overflow: 'hidden',
                }}
              >
                {/* Typeform widget */}
                <div 
                  data-tf-widget="YCVNTd0e" 
                  data-tf-iframe-props="title=Website Enquiry" 
                  style={{ width: '100%', height: '600px' }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>

      </Container>
    </Box>
  );
};

export default Contact;
